<h2 mat-dialog-title class="dialog-header">
  <div class="header-left" style="padding-left: 10px;">
{{ dialogTitle }}
  </div>
  <button type="button" aria-label="Close" (click)="onCancelClick()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>
 
<mat-dialog-content > 
  <div *ngIf="showLoading" class="spinner-container">
    <mat-progress-spinner
      mode="indeterminate"
      diameter="20">
    </mat-progress-spinner>
  </div>
  {{ dialogMessage }}
  <mat-dialog-actions *ngIf="showButtons" align="end">
    <button  *ngIf="showConfirmButton"  mat-flat-button class="submit" (click)="onConfirmClick()" >Confirm</button>
    <button  *ngIf="showOkButton"  mat-flat-button class="ok" (click)="onOkClick()" >Ok</button>
    <button  *ngIf="showFinishButton"  mat-button class="submit" (click)="onFinishClick()">Finish</button>
    <button  *ngIf="showCancelButton"  mat-button class="reset" (click)="onCancelClick()">Cancel</button>
    <button *ngIf="showSubmitButton" class="submit-button" (click)="onSubmitClick()">Submit</button>
  </mat-dialog-actions>
</mat-dialog-content>



  